import React from 'react'
import PropTypes from 'prop-types'

Arrow.propTypes = {
  active: PropTypes.bool.isRequired,
  direction: PropTypes.string.isRequired,
}

export default function Arrow(props) {
  return (
    <i
      className={`fas fa-long-arrow-alt-${props.direction}`}
      style={props.active ? { color: '#002855' } : { color: '#999' }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/AutoTable/Arrow.js